// Libellés et utilitaires des rôles entreprise (multi-utilisateurs).
export const LIBELLE_ROLE = {
  gerant: "Gérant",
  administrateur: "Administrateur",
  comptable: "Comptable",
  saisisseur: "Saisisseur",
  expert_comptable: "Expert-comptable",
  admin: "Admin AERH",
};

// Rôle entreprise effectif (les comptes historiques sans rôle = gérant).
export const roleEffectif = (user) => {
  const r = user?.role || "gerant";
  return r === "utilisateur" ? "gerant" : r;
};

// Rôles attribuables à l'invitation selon la formule.
export const ROLES_INVITABLES = {
  equipe: ["saisisseur", "comptable", "expert_comptable"],
  structure: ["saisisseur", "comptable", "expert_comptable", "administrateur"],
};
